<template>
  <div class="warrantyItemHistory">
    <div class="head-box" style="padding:0 10px;">
      <h4>质保库修改记录</h4>
      <div class="c-flex c-flex-item">
        <el-select
          style="margin-right: 10px"
          width="300px"
          v-model="operationType"
          placeholder="支持按操作类型筛选"
          clearable
          @change="
            historyFpi.page = 1;
            getHistory();
          "
        >
          <el-option
            v-for="(item, i) in options.operationType"
            :key="i"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
        <el-date-picker
          style="width:340px;margin-right:10px;"
          v-model="searchDate"
          type="datetimerange"
          :picker-options="date.pickerOptions"
          start-placeholder="操作时间起"
          end-placeholder="操作时间止"
          :default-time="['00:00:00', '23:59:59']"
          value-format="yyyy-MM-dd HH:mm:ss"
          clearable
          @change="
            historyFpi.page = 1;
            getHistory();
          "
        ></el-date-picker>
        <el-input
          placeholder="请输入操作人姓名"
          v-model="searchValue"
          clearable
          @clear="
            historyFpi.page = 1;
            getHistory();
          "
          @keyup.enter.native="
            historyFpi.page = 1;
            getHistory();
          "
        >
          <el-button
            slot="append"
            icon="el-icon-search"
            @click="
              historyFpi.page = 1;
              getHistory();
            "
          ></el-button>
        </el-input>
      </div>
    </div>
    <div class="content-box" style="height:calc(100% - 100px)">
      <div class="content-table" style="background-color:#f2f2f2">
        <c-modify
          :historyFpi="historyFpi"
          :fields="extFields"
          :fieldsObj="fieldsObj"
          :options="options"
          ref="modify"
        ></c-modify>
      </div>
    </div>
    <el-pagination
      class="pagination"
      @size-change="pageSizeChange"
      @current-change="pageChange"
      :current-page="historyFpi.page"
      :page-sizes="[10, 20, 50, 100]"
      :page-size="historyFpi.rows"
      layout="total, sizes, prev, pager, next, jumper"
      :total="historyFpi.total"
    ></el-pagination>
  </div>
</template>
<script>
export default {
  activated() {
    window.$this = this;
  },
  name: 'WarrantyItemHistory',
  data() {
    window.$this = this;
    return {
      operationType: '',
      searchValue: '',
      searchDate: '',
      extFields: [],
      fieldsObj: {},
      options: {
        codecfg_operationType: { codeId: 'operationType' }
      },
      historyFpi: {
        page: 1,
        rows: 10,
        data: []
      }
    };
  },
  mounted() {
    this.osg.getFields('warrantyItem', () => {
      this.getHistory();
    });
  },
  methods: {
    pageSizeChange(pageSize) {
      this.historyFpi.rows = pageSize;
      this.getHistory();
    },
    pageChange(currentPage) {
      this.historyFpi.page = currentPage;
      this.getHistory();
    },
    getHistory() {
      // 其他getFields查询会更新掉表单的fieldsObj
      let fieldsObj = {};
      this.extFields.map(item => {
        if (item.showList && item.showList.indexOf('6') != -1) {
          item.label = item.nameDisp;
          item.value = item.name;
          fieldsObj[item.name] = item;
        }
      });
      this.fieldsObj = fieldsObj;
      this.searchDate = this.searchDate || [];
      this.osg.ajax(
        'biz/changeLog/query.do',
        {
          smodule: 'warrantyItem',
          page: this.historyFpi.page,
          rows: this.historyFpi.rows,
          'gte:createTime|datetime#and': this.searchDate[0],
          'lte:createTime|datetime#and': this.searchDate[1],
          'is:operation|string#and': this.operationType,
          'regex:updateUserName|string#and': this.searchValue
        },
        res => {
          // 不需要展示变更的字段名
          res.data = res.data.filter(item => {
            item.modifyList = item.modifyList.filter(obj => {
              return (
                this.fieldsObj[obj.field] && this.fieldsObj[obj.field].showList.indexOf('6') != -1
              );
            });
            return item.modifyList.length > 0;
          });
          this.historyFpi = res;
        },
        { noload: true }
      );
    }
  }
};
</script>

<style lang="scss">
.warrantyItemHistory {
  padding: 0 !important;
  .activity-card {
    margin: 10px 0 !important;
    border-radius: 0 !important;
  }
  .pagination {
    border-top: 1px solid #dfe3eb;
    padding: 10px !important;
  }
}
</style>
